import { millisecondsToHours } from 'date-fns';
import { formatDate, getUserTimezone } from '@/utils/helpers';

export const getCLShiftCondition = (startTime: string, endTime: string): string | null => {
  const now = new Date();
  const start = new Date(startTime);
  const end = new Date(endTime);
  const userTimezone = getUserTimezone();

  if (start > now) {
    const diffMs = start.getTime() - now.getTime();
    const diffHours = millisecondsToHours(diffMs);
    const formattedStart = formatDate(start, 'MM/dd/yyyy H:mm zzz', { timezone: userTimezone });
    return `Shift starts in ${diffHours}h (${formattedStart})`;
  }
  if (now >= start && now <= end) {
    const endDiffMs = end.getTime() - now.getTime();
    const endDiffHours = millisecondsToHours(endDiffMs);
    const formattedEnd = formatDate(end, 'MM/dd/yyyy H:mm zzz', { timezone: userTimezone });
    return `Shift ends in ${endDiffHours}h (${formattedEnd})`;
  }

  return null;
};

export const getCLOnCallOverlapMessage = (
  phoneSupportStart?: string | null,
  phoneSupportEnd?: string | null,
  overlapOnCallShiftStart?: string | null,
  overlapOnCallShiftEnd?: string | null,
): string | null => {
  if (!phoneSupportStart || !phoneSupportEnd) {
    return null;
  }
  if (!overlapOnCallShiftStart && !overlapOnCallShiftEnd) {
    return null;
  }

  const phoneStart = new Date(phoneSupportStart);
  const phoneEnd = new Date(phoneSupportEnd);

  // Use phone support times as defaults if overlap times are missing
  const onCallStart = overlapOnCallShiftStart ? new Date(overlapOnCallShiftStart) : phoneStart;
  const onCallEnd = overlapOnCallShiftEnd ? new Date(overlapOnCallShiftEnd) : phoneEnd;

  const overlapStart = Math.max(phoneStart.getTime(), onCallStart.getTime());
  const overlapEnd = Math.min(phoneEnd.getTime(), onCallEnd.getTime());

  if (overlapStart >= overlapEnd) {
    return null;
  }

  const overlapMs = overlapEnd - overlapStart;
  const overlapHours = millisecondsToHours(overlapMs) || 1;

  const userTimezone = getUserTimezone();
  const formattedOverlapStart = formatDate(overlapStart, 'MM/dd/yyyy HH:mm', { timezone: userTimezone });
  const formattedOverlapEnd = formatDate(overlapEnd, 'MM/dd/yyyy HH:mm', { timezone: userTimezone });

  return `CS OnCall Overlap ${overlapHours}h (${formattedOverlapStart} - ${formattedOverlapEnd})`;
};
